<template>
  <div id="home">
    <LazyHydrate when-idle>
      <SfHero class="hero" v-if="heroes && heroes.length">
        <SfHeroItem
          v-for="(hero, i) in heroes"
          :key="i"
          :title="hero.title"
          :subtitle="hero.subtitle"
          :background="hero.background"
          :image="hero.image"
          :buttonText="configGetters.getButtonText(hero)"
          :link="getLink(hero.link)"
          :class="hero.className"
          :nuxtImgConfig="{ modifiers: { format: 'webp' } }"
          style="background-size: auto 100%; background-position: center;"
        >
          <template #title>
            <span class="sf-hero-item__subtitle" :style="hero.subTitleStyle">  {{ hero.style }}{{
              hero.subtitle
            }}</span>
          </template>
          <template #subtitle>
            <span class="sf-hero-item__title" :style="hero.titleStyle">{{
              hero.title
            }}</span>
          </template>
          <template #call-to-action>
            <div v-if="configGetters.getButtonText(hero)">
              <div v-if="getLinkType(hero.link)">
                <nuxt-link :to="localePath(hero.link)">
                  <SfButton>{{ configGetters.getButtonText(hero) }}</SfButton>
                </nuxt-link>
              </div>
              <div v-else>
                <a :href="hero.link" target="_blank">
                  <SfButton>{{ configGetters.getButtonText(hero) }}</SfButton>
                </a>
              </div>
            </div>
          </template>
        </SfHeroItem>
      </SfHero>
    </LazyHydrate>
    <LazyHydrate when-visible>
      <CatProduct />
    </LazyHydrate>
    <LazyHydrate when-visible>
      <SfBannerGrid class="banner-grid" v-if="banners && banners.length">
        <template v-for="item in banners" v-slot:[item.slot]>
          <SfBanner
            v-if="item.image"
            :key="item.slot"
            :button-text="item.buttonText"
            :image="item.image"
            :class="item.class"
            style="position: relative"
            :nuxt-img-config="{ format: 'webp' }"
          >
            <template slot="title">
              <span class="sf-banner__title" :style="item.titleStyle">
                {{ item.title }}
              </span>
            </template>
            <template slot="subtitle">
              <span class="sf-banner__subtitle" :style="item.subTitleStyle">
                {{ item.subtitle }}
              </span>
            </template>
            <template #description>
              <span
                class="sf-banner__description"
                :style="item.descriptionStyle"
              >
                {{ item.description }}
              </span>
            </template>
            <template slot="call-to-action">
              <div>
                <div
                  style="
                    position: absolute;
                    bottom: 2rem;
                    text-align: center;
                    width: 90%;
                  "
                >
                  <div
                    v-if="item.buttonText"
                    style="display: inline-block; margin: auto; min-width: 60%"
                    class="sf-button"
                    @click="goLink(item.link)"
                  >
                    {{ item.buttonText }}
                  </div>
                </div>
              </div>
            </template>
          </SfBanner>
        </template>
      </SfBannerGrid>
    </LazyHydrate>
    <LazyHydrate when-visible>
      <div class="similar-products">
        <SfHeading :title="$t('match_goods')" :level="2" />
        <nuxt-link :to="localePath('/c/0')" class="smartphone-only">
          {{ $t('See_all') }}
        </nuxt-link>
      </div>
    </LazyHydrate>
    <SfCarousel
      v-if="products && products.length"
      class="carousel"
      :settings="{
        peek: 6,
        type: 'carousel',
        rewind: false,
        perView: 4,
        slidePerPage: true,
        gap: 0,
        breakpoints: {
          '1023': {
            perView: 2,
            peek: {
              before: 0,
              after: 50,
            },
          },
        },
      }"
    >
      <template #prev="{ go }">
        <SfArrow
          aria-label="prev"
          class="sf-arrow--left sf-arrow--long"
          @click="go('prev')"
        />
      </template>
      <template #next="{ go }">
        <SfArrow
          aria-label="next"
          class="sf-arrow--right sf-arrow--long"
          @click="go('next')"
        />
      </template>
      <SfCarouselItem
        class="carousel__item "
        v-for="(product, i) in products"
        :key="i"
      >
        <template >
          <SfProductCard
            :key="i"
            v-if="product && product.goodId"
            :title="product.title"
            :image="product.imageUrl"
            :regular-price="
              product.priceMin === product.priceMax
                ? $n(product.priceMax, 'currency')
                : $n(product.priceMin, 'currency') +
                  '-' +
                  $n(product.priceMax, 'currency')
            "
            :show-add-to-cart-button="true"
            :is-on-wishlist="product.isInWishlist"
            :link="
              localePath(
                `/p/${productGetters.getId(product)}/${productGetters.getSlug(
                  product
                )}`
              )
            "
            :isInWishlist="isInWishlist({ product })"
            class="carousel__item__product"
            :scoreRating="product.rate"
            @click:wishlist="toggleWishlist(product)"
            @click:add-to-cart="cartClick(product)"
          >
            <template #image>
              <div
                class="catImg"
                @mouseleave="handlerMouseleaveProduct(product)"
                @mouseover="handlerMouseoverProduct(product)"
              >
                <nuxt-link
                  :to="
                    localePath(
                      `/p/${productGetters.getId(
                        product
                      )}/${productGetters.getSlug(product)}`
                    )
                  "
                >
                  <template
                    v-if="
                      MouseoverProduct &&
                      MouseoverProduct.goodId == product.goodId &&
                      MouseoverProduct.images &&
                      MouseoverProduct.images.length > 1
                    "
                  >
                    <SfHero
                      class="productHero"
                      style="overflow: hidden"
                      :sliderOptions="{
                        type: 'slider',
                        rewind: true,
                        autoplay: 1000,
                        perView: 1,
                        gap: 0,
                        hoverpause: false,
                      }"
                    >
                      <template v-for="(image, i) in MouseoverProduct.images">
                        <SfHeroItem
                          :key="i"
                          :image="image.normal"
                          :nuxtImgConfig="{ modifiers: { format: 'webp' } }"
                        >
                        </SfHeroItem>
                      </template>
                      <template #bullets>
                        <div></div>
                      </template>
                      <template #next>
                        <div></div>
                      </template>
                      <template #prev>
                        <div></div>
                      </template>
                    </SfHero>
                  </template>
                  <SfImage
                    v-else
                    :class="{
                      mouseoverImg:
                        MouseoverProduct &&
                        MouseoverProduct.goodId === product.goodId,
                    }"
                    :src="product.imageUrl"
                    :alt="product.title"
                    :width="190"
                    :height="190"
                  />
                </nuxt-link>
              </div>
            </template>
            <template #price>
              <div style="margin: var(--product-card-margin, 0);height:28.8px;align-content: center;">
                <show-price :regular="product.priceMin === product.priceMax
                ? product.priceMax
                : product.priceMin +
                  '-' +
                  product.priceMax" :special="productGetters.getPrice(product).special" />
              </div>
            </template>
          </SfProductCard>
        </template>
      </SfCarouselItem>
    </SfCarousel>
   
    <LazyHydrate when-visible>
      <SfCallToAction
        :title="$t('Subscribe_to_newsletter')"
        :button-text="$t('Subscribe')"
        :description="$t('Subscribe_to_message')"
        :image="addBasePath('/homepage/newsletter.webp')"
        class="call-to-action"
      >
        <template #button v-if="isSubed">
          <SfButton class="sf-call-to-action__button" data-testid="cta-button">
            {{ $t('Subscribe_to_success') }} : {{ subInfo.email }}
          </SfButton>
        </template>
        <template #button v-else>
          <SfButton
            class="sf-call-to-action__button"
            data-testid="cta-button"
            @click="toggleNewsletterModal"
          >
            {{ $t('Subscribe') }}
          </SfButton>
        </template>
      </SfCallToAction>
    </LazyHydrate>
    <LazyHydrate when-visible>
      <NewsletterModal @email-submitted="onSubscribe" />
    </LazyHydrate>
    <LazyHydrate when-visible>
      <InstagramFeed />
    </LazyHydrate>
  </div>
</template>
<script>
import {
  SfHero,
  SfBanner,
  SfCallToAction,
  SfSection,
  SfCarousel,
  SfProductCard,
  SfImage,
  SfBannerGrid,
  SfHeading,
  SfArrow,
  SfButton,
} from '@storefront-ui/vue';
// useContext,
import {
  computed,
  provide,
  useRouter,
  onMounted,
  ref,
} from '@nuxtjs/composition-api';
import InstagramFeed from '~/components/InstagramFeed.vue';
import NewsletterModal from '~/components/NewsletterModal.vue';
import LazyHydrate from 'vue-lazy-hydration';
import { addBasePath, onSSR } from '@vue-storefront/core';
import { useSystemStore } from '~/stores/system';
import {
  useFacet,
  facetGetters,
  useWishlist,
  useOCart,
  productGetters,
  useSubscribe,
  useUser,
  configGetters,
} from '@bee-hole/coms';
import { useUiState } from '~/composables';
import CatProduct from '~/components/Products/CatProduct.vue';
import showPrice from '~/components/Products/showPrice';
export default {
  name: 'Home0',
  components: {
    InstagramFeed,
    SfHero,
    SfBanner,
    SfCallToAction,
    SfSection,
    SfCarousel,
    SfProductCard,
    SfImage,
    SfBannerGrid,
    SfHeading,
    SfArrow,
    SfButton,
    NewsletterModal,
    LazyHydrate,
    CatProduct,
    showPrice
  },
  setup(props, context) {
    // console.log('context', context);
    // const { $config } = useContext();
    const MouseoverProduct = ref();
    const systemStore = useSystemStore();
    const router = useRouter();
    const { user, load: loadUser } = useUser();
    const { toggleNewsletterModal, isMobile } = useUiState();
    const { result, search: searchLlist } = useFacet('home-goods');
    const {
      addItem: addItemToWishlist,
      isInWishlist,
      removeItem: removeItemFromWishlist,
      wishlist: currentWishlist,
    } = useWishlist();
    const { addItem: addItemToCart, load: loadCart } = useOCart();
    const {
      sub: subscribeAdd,
      load: subscribeList,
      isSubed,
      info: subInfo,
    } = useSubscribe();
    // const { configList, configs } = useConfig('mall_zx_home');
    const products = computed(() => facetGetters.getProducts(result.value));
    const heroes = computed(() => {
      return configGetters.getHeroes(
        context?.root?.$options?.$mallConfig?.mall_zx_home, systemStore.isMobile
      );
    });

    const banners = computed(() => {
      return configGetters.getBanners(
        context?.root?.$options?.$mallConfig?.mall_zx_home, systemStore.isMobile
      );
    });
    onMounted(async () => {
      provide('window', window);
    });

    const onSubscribe = (emailAddress) => {
      subscribeAdd(emailAddress);
      // 弹窗开启关闭事件
      toggleNewsletterModal();
    };

    const removeProductFromWishlist = (productItem) => {
      const product = currentWishlist.value.list.find(
        (wishlistProduct) => wishlistProduct.goodId === productItem.goodId
      );
      removeItemFromWishlist({ product });
    };

    const cartClick = async (product) => {
      if (product?.skus?.length === 1) {
        await addItemToCart({ product, quantity: 1 });
      } else if (productGetters.getId(product)) {
        router.push(
          context.root.localePath(
            `/p/${productGetters.getId(product)}/${productGetters.getSlug(
              product
            )}`
          )
        );
      }
    };

    const addItemForWishlist = (product) => {
      if (product?.product?.skus?.length > 1) {
        router.push(
          context.root.localePath(
            `/p/${product.product.goodId}/${
              product.product?.slug || product.product.title
            }`
          )
        );
      } else {
        product.product.skuId = product.product.skus[0].skuId;
        addItemToWishlist(product);
      }
    };
    const toggleWishlist = (product) => {
      !isInWishlist({ product })
        ? addItemForWishlist({ product })
        : removeProductFromWishlist(product);
    };
    const goLink = (link) => {
      try {
        // 去除js空格
        if (link && link !== '') {
          console.log('1', link);
          link = link?.replace(/\s/g, '');
          if (link?.indexOf('http') !== -1 || link?.indexOf('https') !== -1) {
            return window.open(link, '_blank');
          } else {
            return router.push(context.root.localePath(link));
          }
        }
      } catch (err) {
        return router.push(context.root.localePath(link));
      }
    };
    const getLinkType = (link) => {
      try {
        if (
          link &&
          (link?.indexOf('http') !== -1 || link?.indexOf('https') !== -1)
        ) {
          return false;
        } else {
          return true;
        }
      } catch (err) {
        return false;
      }
    };
    const getLink = (link) => {
      try {
        if (
          link &&
          (link?.indexOf('http') !== -1 || link?.indexOf('https') !== -1)
        ) {
          return link;
        } else {
          return context.root.localePath(link);
        }
      } catch (err) {
        return '/';
      }
    };
    onSSR(async () => {
      await loadUser();
      await searchLlist({ page: 1, limit: 10 });
      await subscribeList();
      await loadCart();
    });
    const handlerMouseoverProduct = (product) => {
      MouseoverProduct.value = product;
    };
    const handlerMouseleaveProduct = (product) => {
      if (MouseoverProduct.value?.goodId === product.goodId) {
        MouseoverProduct.value = null;
      }
    };
    return {
      isMobile,
      toggleWishlist,
      isInWishlist,
      toggleNewsletterModal,
      onSubscribe,
      addBasePath,
      addItemToCart,
      banners,
      heroes,
      products,
      productGetters,
      isSubed,
      subInfo,
      user,
      configGetters,
      cartClick,
      goLink,
      getLinkType,
      getLink,
      handlerMouseoverProduct,
      handlerMouseleaveProduct,
      MouseoverProduct,
    };
  },
};
</script>

<style lang="scss" scoped>
#home {
  min-height: 500px;
  box-sizing: border-box;
  padding: 0 var(--spacer-sm);

  @include for-desktop {
    max-width: 1240px;
    padding: 0;
    margin: 0 auto;
  }
}

.hero {
  margin: var(--spacer-xl) auto var(--spacer-lg);
  --hero-item-background-position: center;

  @include for-desktop {
    margin: var(--spacer-xl) auto var(--spacer-2xl);
  }
  @include for-mobile {
    margin: var(--spacer-sm) auto var(--spacer-sm);
  }
  .sf-hero-item {
    &:nth-child(even) {
      --hero-item-background-position: left;

      @include for-mobile {
        --hero-item-background-position: 30%;

        ::v-deep .sf-hero-item__subtitle,
        ::v-deep .sf-hero-item__title {
          text-align: left;
          width: 60%;
          // padding-left: var(--spacer-sm);
          padding-left: 0;
        }
      }
    }
  }

  ::v-deep .sf-hero__control {
    &--right,
    &--left {
      display: none;
    }
  }
}

.banner-grid {
  --banner-container-width: 50%;
  margin: 0 0 var(--spacer-xl) 0;

  ::v-deep .sf-link:hover {
    color: var(--c-white);
  }
  @include for-mobile {
    margin-top: var(--spacer-sm);
  }

  @include for-desktop {
    margin: var(--spacer-2xl) 0;

    ::v-deep .sf-link {
      --button-width: auto;
      text-decoration: none;
    }
  }
}

.banner {
  &__tshirt {
    background-position: left;
  }

  &-central {
    @include for-desktop {
      --banner-container-flex: 0 0 70%;
    }
  }
}

.similar-products {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: var(--spacer-2xs);
  --heading-padding: 0;
  border-bottom: 1px var(--c-light) solid;

  @include for-desktop {
    border-bottom: 0;
    justify-content: center;
    padding-bottom: 0;
  }
}

.call-to-action {
  background-position: right;
  margin: var(--spacer-xs) 0;

  @include for-desktop {
    margin: var(--spacer-xl) 0 var(--spacer-2xl) 0;
  }
}

.carousel {
  margin: 0 calc(0 - var(--spacer-sm)) 0 0;

  @include for-desktop {
    margin: 0;
  }
  .sf-carousel__slides{
    .sf-carousel-item.glide__slide.carousel__item.glide__slide--clone{
      // display: none;
      opacity: 0;
      width: 0;
    }
    .sf-carousel-item.glide__slide.carousel__item{
      display: flex;
    }
  }
  
  &__item {
    margin: 1.375rem 0 2.5rem 0;

    @include for-desktop {
      margin: var(--spacer-xl) 0 var(--spacer-xl) 0;
    }

    &__product {
      --product-card-add-button-transform: translate3d(0, 30%, 0);
    }
    @include for-mobile{
      max-width: 174px;
    }
  }

  ::v-deep .sf-arrow--long .sf-arrow--right {
    --arrow-icon-transform: rotate(180deg);
    -webkit-transform-origin: center;
    transform-origin: center;
  }
}
@include for-mobile {
  .sf-banner--mobile-size {
    // --banner-height: 100vw;
    --banner-height: 21.4375rem;
  }
}
.banner-grid {
  a {
    position: relative;
  }
}
</style>

<style lang="scss">
#home{
  .sf-hero-item {
    @include for-mobile{
      --hero-item-height : calc((100vw - (var(--spacer-sm) * 2)) / 2.12);
      height: var(--hero-item-height);
      .sf-hero-item__wrapper--mobile{
        min-height: var(--hero-item-height);
      }
    }
  }
  .heroDesktop {
      --hero-item-a: block;
      --hero-item-a-opacity: 0;
      @include for-desktop{
        .sf-hero-item__wrapper--mobile{
          display: var(--hero-item-a);
          opacity: var(--hero-item-a-opacity);
          width: 50%;
          left: 5%;
          position:absolute;
        }
      }
    }
}
</style>
